import styled from 'styled-components';

export const BarChartWidgetStyled = styled.div`
  display: grid;
  width: 100%;
  height: 100%;
`;
